// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_f_-Qu","button":"view-header_button_3jLE1","active":"view-header_active_3dIqf","btnExport":"view-header_btnExport_1x1uR","mr":"view-header_mr_1FUHn"};